import { render, staticRenderFns } from "./VuesticPopover.vue?vue&type=template&id=424296ec&scoped=true"
import script from "./VuesticPopover.vue?vue&type=script&lang=js"
export * from "./VuesticPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424296ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('424296ec')) {
      api.createRecord('424296ec', component.options)
    } else {
      api.reload('424296ec', component.options)
    }
    module.hot.accept("./VuesticPopover.vue?vue&type=template&id=424296ec&scoped=true", function () {
      api.rerender('424296ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-popover/VuesticPopover.vue"
export default component.exports